import { IS_OPERATOR } from './utils';
/** ===== PUBLIC API
 */
export { EventType } from './internalTypes';
//# sourceMappingURL=types.js.map